<template>
	<div class="container">
		<div v-for="(item, idx) in props.data" :key="idx" class="container_item">
			<div class="container_item_img">
				<img :src="item.master_file_path" alt="대가 아이콘" loading="lazy" />
			</div>
			<div class="content">
				<span>{{ item.master_name }}</span>
				<div class="content_company">
					<div class="content_company_img">
						<img :src="item.event_file_path" alt="회사 로고" loading="lazy" />
					</div>
					<span>{{ item.event_name }}</span>
				</div>
				<strong>{{ formatWithSign(item.weekly_rise_ratio) }}%</strong>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import { WeeklyRise } from '@/api/home';
import { formatWithSign } from '@/utils/function/format';

const props = defineProps<{
	data: WeeklyRise[];
}>();
</script>

<style lang="scss" scoped>
.container {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	@media screen and (max-width: 1280px) {
		grid-template-columns: repeat(2, 1fr);
	}
	gap: 1rem;
	&_item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--space-x-small);
		padding: 1.6rem;
		border-radius: var(--border-radius-x-small);
		background-color: var(--color-bg-mid);
		&_img {
			width: 5.2rem;
			height: 4.8rem;
			img {
				object-fit: contain;
				width: 100%;
				height: 100%;
			}
		}
		.content {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: var(--space-xx-small);
			span {
				font-size: var(--font-s-small);
				font-weight: var(--font-w-light);
				line-height: normal;
			}
			strong {
				color: var(--color-danger);
				font-weight: var(--font-w-semi-bold);
				font-size: var(--font-s-regular);
				line-height: 2.1rem;
			}
			&_company {
				display: flex;
				align-items: center;
				gap: var(--border-radius-xx-small);
				span {
					font-size: var(--font-s-mid);
					font-weight: var(--font-w-semi-bold);
					line-height: 2.1rem;
				}
				&_img {
					display: flex;
					justify-content: center;
					width: 2.6rem;
					height: 2.6rem;
					background-color: #202020;
					border-radius: 44%;
					object-fit: contain;
					img {
						border-radius: 44%;
						width: 2.6rem;
						height: 2.6rem;
					}
				}
			}
		}
	}
}
</style>
